import React from 'react';

/**
 * Shared filter button component used by all filter types.
 * Renders an active/inactive styled button that toggles its tooltip.
 */
const FilterButton = React.forwardRef(({ label, activeLabel, isActive, isDisabled, onClick }, ref) => (
    <button
        ref={ref}
        onClick={onClick}
        disabled={isDisabled}
        className={`px-2 py-1 text-xs md:text-sm rounded-full w-full ${
            isActive
                ? 'bg-green-600 text-white font-medium'
                : 'text-gray-500 bg-gray-50 border-gray-200 hover:bg-gray-200 hover:text-gray-600'
        } ${isDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}
    >
        {isActive ? activeLabel : label}
    </button>
));

FilterButton.displayName = 'FilterButton';

export default FilterButton;
